import {
    getAnalytics,
    logEvent,
    setUserProperties,
    setUserId as setFirebaseUserId,
} from 'firebase/analytics';
import { getEnvName } from '../../utils/environmentUtil';

/**
 * Represents FbAnalytics
 * Firebase analytics wrapper
 */
class FbAnalytics {
    static readonly EVENT_NAMES = {
        INVALID_AUTHENTICATION: 'invalid_authentication',
        MAGIC_LINK_ACTIVATION: 'magic_link_activation',
        TRIAGE_STARTED: 'triage_session_started',
        TRIAGE_ENDED: 'triage_session_ended',
        OUTCOME_WORDING: 'triage_outcome_wording_screen',
        PATIENT_OUTCOME_SCREEN: 'patient_record_outcome_screen_visited',
        PATIENT_OUTCOME_SCREEN_DOWNLOADED:
            'patient_record_outcome_screen_downloaded',
        PATIENT_DOWNLOAD_SCREEN: 'patient_record_download_screen_visited',
        PATIENT_DOWNLOAD_SCREEN_DOWNLOADED:
            'patient_record_download_screen_downloaded',
        WELCOME_PAGE_VISITED: 'welcome_page_visited',
        WELCOME_PAGE_CTA_CLICKED: 'welcome_page_cta_button_clicked',
        TERMS_VIEWED: 'terms_viewed',
        TERMS_UNDERSTOOD: 'terms_understood',
        TERMS_OPT_OUT_ACCEPTED: 'terms_opt_out_accepted',
        TERMS_ACCEPTED: 'terms_accepted',
        TERMS_DECLINED: 'terms_declined_confirmed',
        TERMS_DECLINED_CANCEL: 'terms_declined_cancel',
        TERMS_DECLINED_CLICKED: 'terms_declined_button_clicked',
        REGISTRATION: 'registration_viewed',
        REGISTRATION_ELIGIBILITY_COMPLETED:
            'registration_eligibility_completed',
        REGISTRATION_DETAILS_COMPLETED: 'registration_details_completed',
        REGISTRATION_VERIFICATION_COMPLETED:
            'registration_verification_completed',
        MEMBERSHIP_VERIFICATION_SUCCESS: 'membership_verification_success',
        MEMBERSHIP_VERIFICATION_FAIL: 'membership_verification_fail',
        CHAT_ENTERED: 'chat_entered',
        FAQ_HOMEPAGE_VISITED: 'faq_homepage_visited',
        FAQ_MEDICAL_ISSUE_MODAL_OPENED: 'faq_medical_issue_modal_opened',
        FAQ_FEATURED_QUESTION_OPENED: 'faq_featured_question_opened',
        FAQ_TOPIC_PAGE_VISITED: 'faq_topic_page_visited',
        FAQ_TOPIC_QUESTION_OPENED: 'faq_topic_question_opened',
        FAQ_SUPPORT_PAGE_VISITED: 'faq_support_page_visited',
        FAQ_SUPPORT_FORM_SUBMITTED: 'faq_support_form_submitted',
    };

    /**
     * Logs event using firebase analytics
     * @param {string} eventName
     * @param {object} eventParams
     */
    static logEvent(
        eventName: string,
        eventParams?: { [propName: string]: any },
    ) {
        const analytics = getAnalytics();
        logEvent(analytics, eventName, {
            ...eventParams,
            app_domain: 'phio-access',
            env: getEnvName(),
        });
    }

    static setUserProperty(values: { [propName: string]: any }) {
        const analytics = getAnalytics();
        setUserProperties(analytics, { ...values });
    }

    /**
     * Sets the user ID for Firebase Analytics
     * @param {string} userId - The user ID to set (non-PII UID)
     */
    static setUserId(userId: string) {
        const analytics = getAnalytics();
        setFirebaseUserId(analytics, userId);
    }
}

export default FbAnalytics;
